{
	"titleFirstPart": "Vítejte na",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Celkový uložený uhlík"
}
